import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { SurfaceHeader } from '@frontend/surface-header';
import { theme } from '@frontend/theme';
import { useTeamChatSelector } from '../../../providers/team-chat.provider';
import { HeaderExpandCollapseIcon } from '../../header-expand-collapse-icon/header-expand-collapse-icon';
import { ThreadsList } from './threads-list/threads-list';

export const ThreadsSectionPanel = () => {
  const { t } = useTranslation('team-chat');
  const isNavExpanded = useTeamChatSelector((ctx) => ctx.isNavExpanded);
  const collapseNav = useTeamChatSelector((ctx) => ctx.collapseNav);
  const closeConversation = useTeamChatSelector((ctx) => ctx.closeConversation);
  const closeTeamChat = useTeamChatSelector((ctx) => ctx.closeTeamChat);

  const onClickBack = () => {
    closeConversation();

    if (isNavExpanded) {
      collapseNav();
    }
  };

  return (
    <div css={{ height: '100%' }}>
      <SurfaceHeader.Root>
        <SurfaceHeader.Row>
          {!isNavExpanded && (
            <SurfaceHeader.Start>
              <HeaderExpandCollapseIcon />
              <SurfaceHeader.Icon
                label={t('Back')}
                onClick={onClickBack}
                iconName='caret-left-small'
                trackingId='team-chat-2.0-close-threads-section-button'
              />
            </SurfaceHeader.Start>
          )}
          <SurfaceHeader.Title>
            <Icon name='chat' css={{ marginRight: theme.spacing(1.5) }} />
            {t('Threads')}
          </SurfaceHeader.Title>
          <SurfaceHeader.Actions>
            <SurfaceHeader.Icon
              iconName='x'
              onClick={closeTeamChat}
              trackingId='team-chat-2.0-close-team-chat-button'
            />
          </SurfaceHeader.Actions>
        </SurfaceHeader.Row>
      </SurfaceHeader.Root>
      <ThreadsList />
    </div>
  );
};
